export default {
  Validate: {
    ComfirmDeleteBalanceAccount:
      'Bạn có chắc chắn muốn xóa số dư tài khoản <span class="color-green">{0}</span> không?',
    ConfirmDeleteBalanceAccountTitle: 'Xóa số dư tài khoản',
    ChangeDataTitle: 'Cất số dư ban đầu',
    ChangeDataMessge: 'Dữ liệu đã bị thay đổi, bạn có muốn cất số dư ban đầu không?',
    ValidateDuplicateRowInventory: 'Không được phép nhập các dòng có Số lô/Số phiếu nhập giống nhau.',
    ComfirmDeleteBankBalanceAccount: 'Bạn có chắc chắn xóa số dư tài khoản <span class="color-green">{0}</span> không?',
    ComfirmDeleteBankBalanceAccountTitle: 'Xóa số dư ban đầu',
    ComfirmDeleteOPObjectTitle: 'Xóa số dư',
    ComfirmDeleteOPObject: 'Bạn có chắc chắn muốn xóa số dư của {0} <span class="color-green">{1}</span> không?',
    ComfirmDeleteOPMulti: 'Bạn có chắc chắn muốn xóa số dư của các tài khoản đã chọn không?',
    ComfirmDeleteOpeningInventoryTitle: 'Xóa số dư',
    ComfirmDeleteOpeningInventory:
      'Bạn có muốn chắc chắn xóa số dư của vật tư <span class="color-green">{0}</span> không?',
    ComfirmDeleteOpeningInventoryMulti: 'Bạn có muốn chắc chắn xóa số dư của các vật tư đã chọn không?',
    ValidateOutOfRangeAmount: 'Giá trị nhập kho không được vượt quá 14 ký tự.',
    ValidateFocusLeaveControlTitle: 'Nhập số dư ban đầu',
    ValidateFocusLeaveControl: 'Vui lòng nhấn "Lấy dữ liệu" để nhập số dư ban đầu cho {0}.',
    ValidateRequired: '{0} không được bỏ trống.',
    ValidateRequiredCustom: 'Bạn cần nhập thông tin <span class="color-green">{0}</span> cho các dòng số dư chi tiết.',
    ValidateRequiredCustomMulti:
      'Bạn cần nhập các thông tin <span class="color-green">{0}</span> cho các dòng số dư chi tiết.',
    ValidateDuplicateRow: 'Không được phép nhập các dòng có thông tin chi tiết số dư giống nhau.',
    ValidateLengthAmount: '<span class="color-green">{0}</span> vượt quá 14 ký tự.',
    ValidateSelectedAccountingTitle: 'Nhập chi tiết công nợ',
    ValidateSelectedAccounting: 'Vui lòng chọn {0} trước khi nhập chi tiết công nợ.',
  },
  GetOpeningAccountEntry: {
    CheckOpeningFromOldCircularTitle: 'Kiểm tra số dư tài khoản ban đầu',
    CheckOpeningFromOldCircularContent:
      'Một số Tài khoản của dữ liệu <b>{0}</b> đang mở tài khoản chi tiết hoặc quản lý Chi tiết theo khác với Tài khoản trên dữ liệu mới. Bạn vui lòng kiểm tra lại số dư tại chức năng Nhập số dư ban đầu.',
    CheckOpeningFromOldCircularNotExists:
      'Dữ liệu số dư tài khoản ban đầu đã bị thay thế, bạn không thể thực hiện kiểm tra số dư tài khoản ban đầu.',
    CheckOpeningAccountTransferTitle: 'Kết chuyển số dư',
    CheckOpeningAccountOldCircularTransferTitle: 'Xác định kết quả hoạt động',
    CheckOpeningAccountOldCircularTransferContent:
      'Dữ liệu <b>{0}</b> có tài khoản chưa thực hiện kết chuyển. Bạn cần lập chứng từ xác định kết quả hoạt động trước khi Cập nhật Thông tư 24/2024/TT-BTC để đảm bảo tính chính xác của số liệu.',
    CheckOpeningAccountOldCircularTransferContentOther:
      'Dữ liệu <b>{0}</b> có tài khoản chưa thực hiện kết chuyển. Bạn có muốn chương trình tự động lập chứng từ xác định kết quả hoạt động trước khi Cập nhật Thông tư 24/2024/TT-BTC không?',
    CheckOpeningAccountTransferContent:
      'Dữ liệu <b>{0}</b> còn tồn tại ít nhất một tài khoản chưa thực hiện <b>Kết chuyển số dư cuối năm</b> bạn có muốn chương trình tự động kết chuyển không?',
    NotFoundDatabaseChoosedTitle: 'Chọn dữ liệu không thành công',
    NotFoundDatabaseChoosedContent:
      'Không tìm thấy thông tin dữ liệu được chọn. Vui lòng kiểm tra lại dữ liệu bạn đã chọn.',
    ChooseWrongDatabase: 'Bạn đã chọn sai dữ liệu kế toán. Vui lòng kiểm tra lại.',
    CompareDictionaries:
      'Bạn đã chọn sai dữ liệu kế toán hoặc Danh mục đã thay đổi so với dữ liệu cũ, vui lòng sửa lại danh mục hoặc tự nhập lại số dư đầu năm.',
    GetOpeningFailed: 'Lấy số dư không thành công',
    GetOpeningSuccess: 'Lấy số dư thành công',
    ErrorUndefined: 'Đã có lỗi xảy ra',
  },
};
